import React from 'react'

export default function Footer() {
  return (
    <React.Fragment>
  
  <footer id="footer" className="footer">
    <div className="copyright">
      ©{(new Date().getFullYear())} Copyright <strong><span>Focuskon</span></strong>. All Rights Reserved
    </div>
  </footer>
    </React.Fragment>
  )
}
